import GuestCandidateModel from '~/glm/models/shared/guest-import/guest-candidate-model';

const exampleFields1 = {
  names: 'Amy Pond & Rory Williams',
  phone: '732-800-3277',
};
const exampleFields2 = {
  names: 'Sam Williams & Casey Williams & Joy Williams',
  email: 'samwill@gmail.com',
  city: 'Arlington',
  state: 'VA',
  street_1: '900 E25th Street',
  street_2: 'Apt 11G',
  zip: '22219',
};
const example1 = new GuestCandidateModel(exampleFields1);
const example2 = new GuestCandidateModel(exampleFields2);

export default [example1, example2];
